import { config } from "../../common/config/Config";
import createUrl, { DOMAIN } from "../../common/urlCreator/urlCreator";
/*Error constant*/
export const BROWSER_NOT_SUPPORT_ERROR = "ご利用のブラウザは生体認証に対応しておりません。";
export const SYSTEM_ERROR = "システムエラー。誠にお手数ですが、時間をおいて再度お試しください。";
export const EMPTY_REGISTER_TERMINAL_NAME_ERROR = "端末名が入力されておりません。";
export const EMPTY_TERMINAL_NAME_ERROR = "変更後の端末名が入力されておりません。";
export const TERMINAL_NAME_VALIDATOR_FAILED_ERROR = "利用可能な文字は、 半角のアルファベット小文字・大文字、数字、半角スペース、-(ハイフン)、_(アンダーバー)と.(ドット)になります。";
export const FEATURE_NOT_AVAILABLE_ERROR = "お客さまのご契約コースでは生体認証をご利用いただけません。";
export const WEBAUTHN_API_ERROR = "ご利用の環境では、生体認証でのログインが使用できない可能性があります。"
export const WEBAUTHN_API_ERROR_TEXT_LINK = "利用可能な環境、設定はこちら";
export const WEBAUTHN_API_ERROR_2 = "をご確認ください。また、すでにこの端末がご登録済みの場合もありますので、"
export const WEBAUTHN_API_ERROR_2_TEXT_LINK = "登録済みの端末一覧";
export const WEBAUTHN_API_ERROR_3 = "もご確認ください。";
export const MAX_DEVICE_ERROR = `すでに登録数が上限（${config.maxNumberRegisterDevice}台）に達しています。新たに登録する場合は、`;
export const GET_LIST_AUTHENTICATOR_ERROR = "システムエラー。誠にお手数ですが、時間をおいて再度お試しください。";
/* Error messages for CS*/
export const GET_USER_INFO_ERROR = "ユーザー情報の取得に失敗しました";
/*-------------*/
export const BIOMETRIC_INFO_PAGE_URL = createUrl(DOMAIN.SONET, `/support/bioauth/`);
export const BIOMETRIC_INFO_PAGE_URL_WITH_ANCHOR_03 = BIOMETRIC_INFO_PAGE_URL + "#anc-03";
/*Max device register error code from createOption api*/
export const REGISTER_MAX_DEVICE_ERROR_CODE = "REG001";